import React from 'react';
import {
    SpazierbeteiligungFindenPage,
    PflegebeteiligungFindenPage,
    ReitbeteiligungFindenPage,
    ReitbeteiligungFindenPageDynamic,
    PflegebeteiligungFindenPageDynamic,
    SpazierbeteiligungFindenPageDynamic,
} from './index';

const routeConfiguration = () => {
    return [
        {
            path: '/landing/reitbeteiligung-finden',
            name: 'ReitbeteiligungFindenPage',
            component: props => <ReitbeteiligungFindenPage {...props} />,
            loadData: ReitbeteiligungFindenPage.loadData,
        },
        {
            path: '/landing/spazierbeteiligung-finden',
            name: 'SpazierbeteiligungFindenPage',
            component: props => <SpazierbeteiligungFindenPage {...props} />,
            loadData: SpazierbeteiligungFindenPage.loadData,
        },
        {
            path: '/landing/pflegebeteiligung-finden',
            name: 'PflegebeteiligungFindenPage',
            component: props => <PflegebeteiligungFindenPage {...props} />,
            loadData: PflegebeteiligungFindenPage.loadData,
        },
        {
            path: '/landing/reitbeteiligung-finden/:country',
            name: 'ReitbeteiligungFindenPageDynamic',
            component: props => <ReitbeteiligungFindenPageDynamic {...props} />,
            loadData: ReitbeteiligungFindenPageDynamic.loadData,
        },
        {
            path: '/landing/reitbeteiligung-finden/:country/:canton',
            name: 'ReitbeteiligungFindenPageDynamic',
            component: props => <ReitbeteiligungFindenPageDynamic {...props} />,
            loadData: ReitbeteiligungFindenPageDynamic.loadData,
        },
        {
            path: '/landing/reitbeteiligung-finden/:country/:canton/:city',
            name: 'ReitbeteiligungFindenPageDynamic',
            component: props => <ReitbeteiligungFindenPageDynamic {...props} />,
            loadData: ReitbeteiligungFindenPageDynamic.loadData,
        },
        {
            path: '/landing/spazierbeteiligung-finden/:country',
            name: 'SpazierbeteiligungFindenPageDynamic',
            component: props => <SpazierbeteiligungFindenPageDynamic {...props} />,
            loadData: SpazierbeteiligungFindenPageDynamic.loadData,
        },
        {
            path: '/landing/spazierbeteiligung-finden/:country/:canton',
            name: 'SpazierbeteiligungFindenPageDynamic',
            component: props => <SpazierbeteiligungFindenPageDynamic {...props} />,
            loadData: SpazierbeteiligungFindenPageDynamic.loadData,
        },
        {
            path: '/landing/spazierbeteiligung-finden/:country/:canton/:city',
            name: 'SpazierbeteiligungFindenPageDynamic',
            component: props => <SpazierbeteiligungFindenPageDynamic {...props} />,
            loadData: SpazierbeteiligungFindenPageDynamic.loadData,
        },
        {
            path: '/landing/pflegebeteiligung-finden/:country',
            name: 'PflegebeteiligungFindenPageDynamic',
            component: props => <PflegebeteiligungFindenPageDynamic {...props} />,
            loadData: PflegebeteiligungFindenPageDynamic.loadData,
        },
        {
            path: '/landing/pflegebeteiligung-finden/:country/:canton',
            name: 'PflegebeteiligungFindenPageDynamic',
            component: props => <PflegebeteiligungFindenPageDynamic {...props} />,
            loadData: PflegebeteiligungFindenPageDynamic.loadData,
        },
        {
            path: '/landing/pflegebeteiligung-finden/:country/:canton/:city',
            name: 'PflegebeteiligungFindenPageDynamic',
            component: props => <PflegebeteiligungFindenPageDynamic {...props} />,
            loadData: PflegebeteiligungFindenPageDynamic.loadData,
        },
    ];
};

export default routeConfiguration().map((routeConfiguration, index) => routeConfiguration);
